import React, {useEffect, useState} from 'react';
import Translate from "localization/Translate";
import {useDispatch, useSelector} from "react-redux";
import {useActionListener} from "redux-action-listener-hook";
import {
    cancelAllPendingRfidTags,
    closeAdministration,
    removeProduct,
    setBlockScannersNormalAction,
    setLoading,
    showDialogue,
    triggerFindScannedProduct
} from "../../redux/actions";
import {
    APPLY_PROMOTIONS,
    PRODUCT_RFID_TAG_DETECTED,
    SCANNER_DETECTED,
    START_RFID_READER,
    STOP_RFID_READER
} from "../../redux/actionTypes";
import RFIDService from "../../redux/rfid/RFIDService";
import scanQR from "../images/DecathlonPurple/scanQR.png";
import scanBarcode from "../images/DecathlonPurple/scanBarcode.png";
import {cloneProduct} from "../../redux/selectors";
import {getTranslate} from "../../localization/localizeSlice";
import Button from "../../buttons/Button";
import {createBarcode} from "../../util/helperFunctions";


const API = {
    franchiseAccountNumber: false,
    getUrl: () => window.AppConf.preprod ? "https://accio-eu10.erply.com" : "https://accio-eu.erply.com",
    handleProductScanned: (code, setMessage, RFIDTag, productsInBasket) => {
        API.getProduct(code).then((response) => {
            console.log("getProduct", response);
            let product = API.getProductInfo(response.payload.dataXml);
            console.log("getProduct", {product});
            setMessage(`${product.code} ${product.name}`);
            API.saveProduct(response).then((response) => {
                setMessage('Product saved');
                let barcode = typeof RFIDTag !== "undefined" ? createBarcode(RFIDTag.GTIN, RFIDTag.SERIAL_NUMBER) :
                    product?.sgtin ?? code?.sgtin ?? product.code;
                if(typeof productsInBasket.find((el) => el.data.code === barcode) !== "undefined"){
                    API.dispatch({
                        type: APPLY_PROMOTIONS
                    });
                }else{
                    let productInBasket = productsInBasket.find((el) => {
                        if(typeof el.data?.RFIDTag !== "undefined"){
                            return createBarcode(el.data.RFIDTag.GTIN, el.data.RFIDTag.SERIAL_NUMBER) === barcode;
                        }
                        return false;
                    });
                    if(typeof productInBasket !== "undefined"){
                        API.dispatch(removeProduct(cloneProduct(productInBasket)));
                    }
                    API.dispatch(triggerFindScannedProduct(barcode, true));
                }
                API.dispatch(closeAdministration());
                API.dispatch({type: START_RFID_READER});
            }, (response) => {
                setMessage('Product not saved');
                if(typeof RFIDTag !== "undefined"){
                    API.dispatch(cancelAllPendingRfidTags(() => {
                        API.dispatch({type: START_RFID_READER});
                    }));
                }
            });
        }, (response) => {
            setMessage('We cannot find a 2nd life price for this product');
            if(typeof RFIDTag !== "undefined"){
                API.dispatch(cancelAllPendingRfidTags(() => {
                    API.dispatch({type: START_RFID_READER});
                }));
            }
        });
    },
    getProduct: (code) => {
        return new Promise((resolve, reject) => {
            API.dispatch(setLoading(true));
            let searchCode = typeof code.sgtin !== 'undefined' ? 'sgtin=' + code.sgtin : 'epc=' + code.epc;
            fetch(API.getUrl() + "/occazionFlow?storeNumber=" + API.storeNumber + '&' + searchCode, {headers: {clientCode: API.user.clientCode, sessionKey: API.user.sessionKey}}).then(response => {
                return response.json();
            }).then((response) => {
                console.log('get occazionFlow response', response);
                if(response.status.responseStatus === "ok"){
                    resolve(response.data);
                }else{
                    reject(response);
                }
            }).catch((response) => {
                console.log('get occazionFlow api request failed', response);
                reject(response);
            }).finally(() => {
                API.dispatch(setLoading(false));
            });
        });
    },
    saveProduct: (productMessage) => {
        return new Promise((resolve, reject) => {
            if(API.franchiseAccountNumber === false){
                reject("No franchise account available");
                return;
            }
            API.dispatch(setLoading(true));
            fetch(API.getUrl() + "/occazionFlow?accountNumber=" + API.franchiseAccountNumber, {
                method: 'POST',
                headers: {
                    clientCode: API.user.clientCode,
                    sessionKey: API.user.sessionKey
                },
                body: JSON.stringify(productMessage)
            }).then(response => {
                return response.json();
            }).then((response) => {
                console.log('post occazionFlow response', response);
                if(response.responseStatus === "ok"){
                    resolve(response.data);
                }else{
                    reject(response);
                }
            }).catch((response) => {
                console.log('post occazionFlow api request failed', response);
                reject(response);
            }).finally(() => {
                API.dispatch(setLoading(false));
            });
        });
    },
    getProductInfo: (xml) => {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(xml, 'text/xml');
        let code = xmlDoc.getElementsByTagName('ItemID')[0].childNodes[0].nodeValue;
        let name = xmlDoc.getElementsByTagName('Description')[0].childNodes[0].nodeValue;
        let sgtin = Array.from(xmlDoc.getElementsByTagName('AlternativeItemID')).find(el => {return el.getAttribute('Type') === 'SGTIN';})?.textContent;
        return {
            code,
            name,
            sgtin
        }
    },
    updateProducts: (codes, setMessage, productsInBasket) => {
        return new Promise((resolve, reject) => {
            console.log("update products", {codes, setMessage, productsInBasket});
            if(codes.length === 0){
                resolve();
                return;
            }
            let code = codes.shift();

            API.getProduct(code)
                .then(
                    (response) => {
                        let product = API.getProductInfo(response.payload.dataXml);
                        console.log("getProduct", {product});
                        let productTitle = `${product.code} ${product.name}`;
                        setMessage(API.translate('${productTitle} found', {productTitle}));
                        API.saveProduct(response).then((response) => {
                            setMessage(API.translate('${productTitle} saved', {productTitle}));
                            let barcode = product?.sgtin ?? code?.sgtin ?? product.code;
                            if(!(typeof productsInBasket.find((el) => el.data.code === barcode) !== "undefined")){
                                let productInBasket = productsInBasket.find((el) => {
                                    if(typeof el.data?.RFIDTag !== "undefined"){
                                        return createBarcode(el.data.RFIDTag.GTIN, el.data.RFIDTag.SERIAL_NUMBER) === barcode;
                                    }
                                    return false;
                                });
                                if(typeof productInBasket !== "undefined"){
                                    API.dispatch(removeProduct(cloneProduct(productInBasket)));
                                }
                                API.dispatch(triggerFindScannedProduct(barcode, true));
                            }
                            API.updateProducts(codes, setMessage, productsInBasket).then(resolve, reject);
                        }, (response) => {
                            setMessage(API.translate('${productTitle} not saved', {productTitle}));
                            API.updateProducts(codes, setMessage, productsInBasket).then(resolve, reject);
                        });
                    }, () => {
                        API.updateProducts(codes, setMessage, productsInBasket).then(resolve, reject);
                    });
        });
    },
    checkAllProducts: (productsInBasket, setMessage) => {
        let productCodes = productsInBasket.reduce((acc, el) => {
            let sgtin;
            if(el.data.code.length === 30){
                sgtin = el.data.code;
            }else{
                let gtin = el.data.code2;
                let serialNumber = el.data?.RFIDSerialNumber ?? el.data?.RFIDTag?.SERIAL_NUMBER ?? "0";
                if(serialNumber === "NULL_VALUE"){
                    serialNumber = "0";
                }
                let RFIDTagGtin = el.data?.RFIDTag?.GTIN ?? "NULL_VALUE";
                if(RFIDTagGtin !== "NULL_VALUE"){
                    gtin = RFIDTagGtin;
                }
                sgtin = createBarcode(gtin, serialNumber);
            }
            acc.push({sgtin});
            return acc;
        }, []);

        API.updateProducts(productCodes, setMessage, productsInBasket).then(() => {
            API.dispatch({
                type: APPLY_PROMOTIONS
            });
        });
    }
}

let tagDetectCount = 0;
export default function () {
    const [message, setMessage] = useState('Scan the product to retrieve the correct price');
    const [updateLog, setUpdateLog] = useState([]);
    const addToUpdateLog = (message) => {
        setUpdateLog(prevLog => [...prevLog, message]);
    }

    API.storeNumber = useSelector(state => state.rootReducer.warehouse.code);
    API.user = useSelector(state => state.rootReducer.user);
    const productsInBasket = useSelector(state => state.rootReducer.productsInBasket);
    API.dispatch = useDispatch();
    let franchiseInfo = useSelector(state => state.rootReducer.franchiseInfo);
    API.franchiseAccountNumber = franchiseInfo?.accounts?.master ?? API.user.clientCode;

    API.translate = useSelector(state => getTranslate(state));

    useEffect(() => {
        API.dispatch(setBlockScannersNormalAction(true));
        return () => {
            API.dispatch(setBlockScannersNormalAction(false));
            tagDetectCount = 0;
        }
    }, []);

    useActionListener(SCANNER_DETECTED, (dispatch, action) => {
        API.handleProductScanned({sgtin: action.payload}, setMessage, undefined, productsInBasket);
    });

    let getNumberOfPendingRFIDProducts = () => {
        return Object.keys(RFIDService.RFIDProducts).reduce((acc, el) => {
            acc += RFIDService.RFIDProducts[el].length;
            return acc;
        },0);
    }

    useActionListener(PRODUCT_RFID_TAG_DETECTED, (dispatch, action) => {
        let RFIDTag = action.payload.RFIDTag;
        dispatch({type: STOP_RFID_READER});
        tagDetectCount++;
        let currentTagDetectNo = tagDetectCount;
        setTimeout(() => {
            console.log({tagDetectCount, currentTagDetectNo, RFIDTag});
            if(currentTagDetectNo === tagDetectCount){
                if(getNumberOfPendingRFIDProducts() > 1){
                    dispatch(showDialogue(
                        "Multiple products scanned",
                        "Please remove all the added products from the basket and scan only one item!",
                        "Ok",
                        () => {
                            dispatch(cancelAllPendingRfidTags(() => {
                                dispatch({type: START_RFID_READER});
                            }));
                        }, undefined, undefined, false, undefined, undefined, true)
                    );
                    return;
                }else{
                    API.handleProductScanned({epc: RFIDTag.EPC}, setMessage, RFIDTag, productsInBasket);
                }
            }
        }, 1000);
    });

    return (
        <div style={{
            position: "absolute",
            left: 0,
            right:0,
            top: 0,
            bottom: 0
        }}>
            <h1 style={{marginLeft: '1.43rem'}}><Translate id={'2nd life price'}/></h1>
            <div style={{
                width: "100%",
                borderTop: "0.07rem solid gray",
                marginBottom: "0.71rem"
            }}/>
            <div style={{
                margin: "1.43rem",
                fontSize: '1.29rem'
            }}>
                <p><Translate id={message}/></p>
                <ImageText image={scanBarcode} text={"Scan the barcode of the RFID tag"}/>
                <ImageText image={scanQR} text={"Scan the QR of the Mobiprint price label"}/>
                <ImageText image={scanBarcode} text={"Scan the barcode of the product on Cube In Store"}/>
                <Button
                    type="button"
                    className={"largeButton blueButton"}
                    name={<Translate id={"Check all products in basket"}/>}
                    onClick={() => {
                        API.checkAllProducts(productsInBasket, addToUpdateLog);
                    }}
                />
                <ul>
                    {
                        updateLog.map((entry, index) => {
                            return <li key={index}><Translate id={entry}/></li>
                        })
                    }
                </ul>
            </div>
        </div>
    );
}

const ImageText = ({image, text}) => {
    return (<div style={{display: 'flex', alignItems: 'center', gap: '1rem'}}>
        <img src={image} height={32}/>
        <div><Translate id={text}/></div>
    </div>);
}
